import { NavigationStep } from './navigation';

export class SetCurrentStepAction {
  static readonly type = '[NAVIGATION] SetCurrentStep';
  constructor(public step: NavigationStep) {}
}

export const SetCurrentStep = 'SET_CURRENT_STEP';
